import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import axios from "axios";

export const getService = createAsyncThunk(
    "service/getClientService",
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/client/service`);
            // console.log(response);
            if(response.data.sucess){
                return response.data.data;
            }else{
                return null;
            }
           
        }
        catch (err) {
            return rejectWithValue("Failed to get all service!");
        }
    })

const serviceSlice = createSlice({
    name: "service",
    initialState: {
        service:null,
    },
    extraReducers: builder => {
        builder
          .addCase(getService.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getService.fulfilled, (state, action) => {
            state.service=action.payload
            state.status = 'idle'
          }) .addCase(getService.rejected, (state, action) => {
            // state.service=action.payload
            state.status = 'failed'
          })
      }
    
})
export default serviceSlice;

// extraReducers: {
//     [getService.fulfilled]: (state, { payload }) => {
//         state.service = payload;
//     },
// }